export default __webpack_public_path__ + "static/morestudio-d92dac20baafa4f9ca9d964f8d238b73.png";